import { render } from "./product-image-attachment.vue?vue&type=template&id=3ffcfe51"
import script from "./product-image-attachment.vue?vue&type=script&lang=js"
export * from "./product-image-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__